module.exports = __webpack_public_path__ + "static/media/logo.5452c354.jpg";